var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"google-button",attrs:{"href":_vm.oAuthLoginUrl}},[_c('img',{staticClass:"button-icon",attrs:{"src":require("@/assets/G_icon.svg"),"alt":""}}),_c('span',{staticClass:"button-title"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }